import {
  DELETE_DISCOUNT_RULE,
  DiscountRuleActionTypes,
  DiscountRuleState,
  GET_DISCOUNT_RULE,
  GET_DISCOUNT_RULES_LIST, POST_DISCOUNT_RULE, PUT_DISCOUNT_RULE, UPDATE_DISCOUNT_RULE_FILTERS
} from '../types/discountrule.types';
import { Reducer } from 'redux';

const initialState: DiscountRuleState = {
  discountRules: [],
  selectedDiscountRule: null,
  postSuccess: null,
  lastFetch: null,
  totalPages: 1,
  totalElements: 0,
  filters: null
};

export const discountRuleReducer: Reducer<DiscountRuleState> = (
  state: DiscountRuleState = initialState, action
) => {
  const timeOfAction = new Date().getTime();
  switch ((action as DiscountRuleActionTypes).type) {
    case GET_DISCOUNT_RULES_LIST:
      return {
        ...state,
        discountRules: action.payload.page.content,
        selectedDiscountRule: null,
        postSuccess: null,
        lastFetch: timeOfAction,
        totalElements: action.payload.page.totalElements,
        totalPages: action.payload.page.totalPages
      };
    case GET_DISCOUNT_RULE:
      return {
        ...state,
        postSuccess: null,
        selectedDiscountRule: action.payload.selectedDiscountRule,
        lastFetch: timeOfAction
      };
    case POST_DISCOUNT_RULE:
      return {
        ...state,
        postSuccess: true,
        selectedDiscountRule: action.payload.newDiscountRule,
        lastFetch: timeOfAction
      };
    case PUT_DISCOUNT_RULE:
      return {
        ...state,
        selectedDiscountRule: action.payload.selectedDiscountRule,
        postSuccess: true,
        lastFetch: timeOfAction
      };
    case DELETE_DISCOUNT_RULE:
      return {
        ...state,
        selectedDiscountRule: null,
        lastFetch: timeOfAction
      };
    case UPDATE_DISCOUNT_RULE_FILTERS:
      return {
        ...state,
        filters: action.payload.filters
      };
    default:
      return state;
  }
};